"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    align-items: center;\n    justify-content: flex-start;\n    flex-direction: column;\n    z-index: 2;\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var base = function base(_ref) {
  var theme = _ref.theme,
      inline = _ref.inline,
      global = _ref.global;
  return {
    display: inline ? 'inline-flex' : theme.display,
    width: theme.width,
    minWidth: theme.minWidth,
    position: global ? 'absolute' : 'relative',
    top: global ? 0 : 'auto',
    left: global ? 0 : 'auto'
  };
};

var Root = _styledComponents["default"].div(_templateObject(), function (props) {
  return base(props);
});

var _default = Root;
exports["default"] = _default;